module.exports = __webpack_public_path__ + "static/media/1-huojing.ef94bc4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/1-huojing.mp3
// module id = 2zYB
// module chunks = 208